<template>
  <div id="yes-no">
    {{ qData }}
    <v-card class="mb-12 mx-auto">
      <v-card-text>
        <p class="font-weight-medium">{{ qData.text }}</p>
        <v-radio-group v-model="radios" :mandatory="false">
          <v-radio label="yes" value="yes"></v-radio>
          <v-radio label="no" value="no"></v-radio>
        </v-radio-group>
        <v-divider></v-divider>
        <pre>{{ radios }}</pre>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    qData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      radios: 'yes',
    };
  },
};
</script>

<style lang="scss" scoped></style>
